<div id="container" *ngIf="task.currentStatus!='COMPLETE' && task.additionalString==null">
    <div class="truncate">{{task.title}}</div>
    <div id="indicator" [ngStyle]="{'background-color': task.color}"></div>
</div>
<div id="container"  *ngIf="task.currentStatus=='COMPLETE' && task.additionalString==null">
    <div class="truncate_complete"><s>{{task.title}}</s></div>
    <div id="indicator" [ngStyle]="{'background-color': '999'}"></div>
</div>
